import React, { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import SocialAuthChecker from '../../../../features/components/SocialAuthChecker'
import FacebookAdsPreviewList from '../../../CampaignsSummary/AdsList/FacebookAdsPreviewList'

import { getAds, clearAds } from '../../../../modules/actions/ads'
import { adsSelector } from '../../../../modules/selectors/ads'
import { selectedFacebookAdAccountSelector } from '../../../../modules/selectors/adAccounts'
import { selectedPartnershipRightsHolderIdSelector } from '../../../../modules/selectors/partnerships'

import { FACEBOOK_PLATFORM } from '../../../../constants/selectLists/platformList'

const FacebookAdsSection = () => {
  const dispatch = useDispatch()

  const ads = useSelector(adsSelector)
  const { id: facebookAdAccountId } = useSelector(selectedFacebookAdAccountSelector)
  const partnershipRightsHolderId = useSelector(selectedPartnershipRightsHolderIdSelector)

  // pass only internal ads to FacebookAdsPreviewList
  // when ad get approved it's status changes but it still stuck in the reducers ads list, this helps to clean it up
  const internalAds = ads.filter(({ effective_status }) => effective_status === 'pending_approval')

  const getInternalAdsData = useCallback(() => {
    dispatch(
      getAds(
        {
          rights_holder_account_id: partnershipRightsHolderId,
          detail: true,
          date_preset: 'lifetime',
          internal: true,
          approval_status: 'pending_approval'
        },
        FACEBOOK_PLATFORM
      )
    )
  }, [dispatch, partnershipRightsHolderId])

  useEffect(
    () => () => {
      dispatch(clearAds())
    },
    [dispatch]
  )

  return (
    <SocialAuthChecker
      platform={FACEBOOK_PLATFORM}
      dataFetch={getInternalAdsData}
      adAccountId={facebookAdAccountId}
      authFailureText="Please authenticate with Facebook to retrieve the list of ads."
    >
      <FacebookAdsPreviewList
        adsList={internalAds}
        showStatus={false}
        showDetails={false}
        showMetrics={false}
        showActionsDropdown={false}
        showActionsButtons={true}
        noDataText="There are no ads waiting for approval."
        checkPlacements={false}
        shouldLoadAllCTA
        isAdApprovalsPage
      />
    </SocialAuthChecker>
  )
}

export default FacebookAdsSection
